import React from 'react'
import Navbar from '../Navbar'
import "../pages/ThankYou.css"
import { Helmet } from 'react-helmet-async'


const ThankYou = () => {

    function handleClick() {
        document.getElementById('anchorHome').click()
    }
    return (
        <>
            <Helmet>
                <link rel="canonical" href="https://robustik.com/thankyou" />
            </Helmet>
            <section className='hero thank-you'>
                <div className="container text-center">
                    <div className=' hh1 font-extrabold' data-aos="fade-up" data-aos-delay="200">
                        <span className="text-primary">Thanks</span> for reaching out!
                    </div>
                    <p style={{ "marginTop": "10px" }} data-aos="fade-up" data-aos-delay="300">Your message just showed up in our inbox. Talk to you soon!</p>
                    <div className="font-extralight" data-aos="fade-up" data-aos-delay="400"></div>

                    <div data-aos="fade-up" data-aos-delay="500" >
                        <button onClick={handleClick}><div>Back to Home<i></i></div></button>
                    </div>
                </div>
            </section>

        </>
    )
}

export default ThankYou
